var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slider-item slider-item--zoom" }, [
    _c("h2", {
      ref: "title",
      staticClass: "slider-item__title",
      domProps: { innerHTML: _vm._s(_vm.title) }
    }),
    _vm._v(" "),
    _c(
      "div",
      { ref: "iconList", staticClass: "slider-item__icon-list-wrapper" },
      [
        _c(
          "ul",
          { staticClass: "slider-item__icon-list" },
          _vm._l(_vm.listLine1, function(item) {
            return _c(
              "li",
              { key: item.label, staticClass: "slider-item__icon-list-item" },
              [
                _c("img", {
                  attrs: {
                    src:
                      "/ressources/logged/img/illustrations/recap2024/slsy-" +
                      item.icon +
                      ".svg",
                    alt: item.label
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "slider-item__icon-list-item-number" },
                  [_vm._v(_vm._s(item.number))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "slider-item__icon-list-item-label" },
                  [_vm._v(_vm._s(item.label))]
                )
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "slider-item__icon-list" },
          _vm._l(_vm.listLine2, function(item) {
            return _c(
              "li",
              { key: item.label, staticClass: "slider-item__icon-list-item" },
              [
                _c("img", {
                  attrs: {
                    src:
                      "/ressources/logged/img/illustrations/recap2024/slsy-" +
                      item.icon +
                      ".svg",
                    alt: item.label
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "slider-item__icon-list-item-number" },
                  [_vm._v(_vm._s(item.number))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "slider-item__icon-list-item-label" },
                  [_vm._v(_vm._s(item.label))]
                )
              ]
            )
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }